import Link from "next/link";
import Button from "../Button";
import Image from "next/image";

type Props = {
  hideButtons?: boolean;
};

const Navbar: React.FC<Props> = ({ children, hideButtons }) => {
  return (
    <nav className="w-full py-4 px-2 md:px-4 flex-grow-0">
      <div className="w-full max-w-6xl h-full mx-auto flex justify-between items-center">
        <div className="w-64 flex justify-start">
          <Link passHref href={`${process.env.NEXT_PUBLIC_SITE_URL}`}>
            <a className="flex items-center justify-center">
              <Image
                src="/static/logo/xtribe-logo-128.png"
                height={40}
                width={137.1875}
                className="h-12"
              />
            </a>
          </Link>
        </div>
        {!hideButtons && (
          <>
            <div className="hidden sm:flex">
              <Link passHref href={`${process.env.NEXT_PUBLIC_SITE_URL}`}>
                <a className="mx-4 text-sm text-gray-700 hover:text-primary">
                  Start
                </a>
              </Link>
              <Link href="/pricing">
                <a
                  href="/pricing"
                  className="mx-4 text-sm text-gray-700 hover:text-primary"
                >
                  Preise
                </a>
              </Link>
            </div>
            <div className="items-center w-64 flex justify-end">
              <div className="hidden sm:inline-block">
                <a
                  href={`${process.env.NEXT_PUBLIC_AUTH_URL}/signin`}
                  rel="prefetch"
                >
                  <Button auto size="small" className="sm:mr-4" type="abort">
                    Anmelden
                  </Button>
                </a>
              </div>
              <div className="inline-block sm:hidden">
                <a
                  href={`${process.env.NEXT_PUBLIC_AUTH_URL}/signin`}
                  rel="prefetch"
                >
                  <Button auto size="small" className="sm:mr-4">
                    Anmelden
                  </Button>
                </a>
              </div>

              <div className="hidden sm:inline-block">
                <Link
                  passHref
                  href={`${process.env.NEXT_PUBLIC_SITE_URL}/start`}
                >
                  <a>
                    <Button auto type="success" size="small">
                      Registrieren
                    </Button>
                  </a>
                </Link>
              </div>
            </div>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
